module.exports = __webpack_public_path__ + "static/media/ingredients-beets.8bf4a23a.png";